import { Grid, Paper } from '@mui/material';
import PageHeading from '../../../../Components/PageHeading';
import InputConfig from '../../../../Components/InputConfig';
import { useContext } from 'react';
import useCommonStyles from '../../../../commonStyles';

import CheckBoxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';

/**
 * @name MaxAdDurationConfig
 * @description This component is an editor for MaxAdDuration configuration.
 * ```
 *  {
 *  "maxAdDuration": { "enabled": true, "duration": 60000 }
 *  }
 * ```
 * @param {{keyData: 'networkData.maxAdDuration'}} keyData - A key used to identify the configuration in the `rawConfig` object.
 */
const MaxAdDurationConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Max Ad Duration"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Max Ad Duration']}
				description="Manage Max Ad Duration Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginLeft: '5rem', marginTop: '3rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={`${keyData}.enabled`}
						label="Enabled"
						disabled={false}
						style={{ marginTop: '3rem', width: '10%' }}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Duration(ms)"
						keyData={`${keyData}.duration`}
						editable={!!rawConfig[`${keyData}.enabled`]}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default MaxAdDurationConfig;
